export default class InvoiceInformation {
    vendor: string;
    project_NaN: string;
    project_description: string;
    customer: string;
    project_manager: string;
    invoice_NaN: string;
    total: number | null;

    constructor(data?: Partial<InvoiceInformation>) {
        this.vendor = data?.vendor ?? '';
        this.project_NaN = data?.project_NaN ?? '';
        this.project_description = data?.project_description ?? '';
        this.customer = data?.customer ?? '';
        this.project_manager = data?.project_manager ?? '';
        this.invoice_NaN = data?.invoice_NaN ?? '';
        this.total = data?.total ?? null;
    }
}
